import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { RegistrationIntermediary } from '@gipi-registration/intermediary/models/intermediary.model';
import { RegistrationIntermediaryService } from '@gipi-registration/intermediary/services/intermediary.service';
import { OptionActiveSituation, OptionActiveSituationEnum } from '@gipi-shared/enums/option-active-situation.enum';
import { APP_MESSAGES, DocumentUtil, GIPIAbstractComponent, GIPIBaseService, INJECTOR, ObjectUtil, StringUtil } from '@gipisistemas/ng-core';

export interface IntermediaryFormData {
    typeOperation: 'NEW' | 'EDIT' | 'VIEW';
    intermediary: RegistrationIntermediary;
}

@Component({
    templateUrl: './intermediary-form-dialog.component.html',
    styles: [`
        :host {
            display: flex;
            flex-direction: column;
            height: 100%;
        }
    `]
})
export class IntermediaryFormDialogComponent extends GIPIAbstractComponent implements OnInit, OnDestroy {

    public typeOperation: 'NEW' | 'EDIT' | 'VIEW' = 'NEW';

    public intermediary: RegistrationIntermediary = new RegistrationIntermediary();

    public optionActiveSituationEnum: typeof OptionActiveSituationEnum = OptionActiveSituationEnum;
    public optionActiveSituationValue: OptionActiveSituation = 'ENABLED';

    constructor(
        protected service: RegistrationIntermediaryService,
        protected baseService: GIPIBaseService,
        protected activatedRoute: ActivatedRoute,
        public dialogRef: MatDialogRef<IntermediaryFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IntermediaryFormData = { typeOperation: 'NEW', intermediary: null },
    ) {
        super(baseService, activatedRoute);
        this.dialogRef.disableClose = true;
    }

    ngOnInit() {
        super.ngOnInit();
        this.typeOperation = this.data.typeOperation;
        if (this.typeOperation !== 'NEW') {
            this.intermediary = this.data.intermediary;

            if (!this.intermediary.enabled) {
                this.optionActiveSituationValue = 'DISABLED';
            }
        }
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public confirm(): void {
        try {
            if (ObjectUtil.isNull(this.intermediary)) {
                return;
            }
            if (StringUtil.isEmpty(this.intermediary.cnpj)) {
                this.addWarningMessage('Campo CNPJ é obrigatório e não foi informado');
                return;
            }
            if (!DocumentUtil.isValidCnpj(this.intermediary.cnpj)) {
                this.addWarningMessage('CNPJ informado é inválido');
                return;
            }
            if (StringUtil.isEmpty(this.intermediary.name)) {
                this.addWarningMessage('Campo nome é obrigatório e não foi informado');
                return;
            }
            if (this.intermediary.name.length < 3) {
                this.addWarningMessage('Campo nome deve conter no mínimo 3 caracteres');
                return;
            }
            if (StringUtil.isEmpty(this.intermediary.username)) {
                this.addWarningMessage('Campo nome do usuário é obrigatório e não foi informado');
                return;
            }
            if (this.intermediary.username.length < 3) {
                this.addWarningMessage('Campo nome do usuário deve conter no mínimo 3 caracteres');
                return;
            }
            this.loading = true;

            this.intermediary.enabled = (this.optionActiveSituationValue === 'ENABLED');

            this.service.save(this.intermediary).toPromise().then(() => {
                this.addSuccessMessage(INJECTOR.get(APP_MESSAGES).SUCCESS);
                this.loading = false;
                this.close('RELOAD_TABLE');
            }, error => {
                throw new Error(error);
            });
        } catch (e) {
            this.loading = false;
            this.handleError(e);
        }
    }

    /**
     * @template RELOAD_TABLE Dá reload na grid atualizando os registros
     * @template REMARK_SELECTED Volta a tela anterior e seleciona os registros na grid
     * @template NONE Não acontece nada, só volta para tela anterior
     */
    public close(operation: 'RELOAD_TABLE' | 'REMARK_SELECTED' | 'NONE'): void {
        this.dialogRef.close(operation);
    }

}
